<template>
  <base-button
    class="relative w-full flex items-center gap-2 rounded-xs p-3 ring ring-grey-30 between "
    :class="{ 'bg-grey-90': modelValue && unavailable }"
    @click="$emit('click')"
  >
    <span class="line-clamp-1 grow" :class="{ 'c-grey-20': !modelValue }">
      <!-- @slot Slot for label -->
      <slot />
    </span>
    <span v-if="showPlaceholderStockHint && modelValue && unavailable" class="shrink-0 text-xs c-grey-20">
      {{ isNotifyMe ? $t.notifyMe : $t.outOfStock }}
    </span>
    <vf-icon dir="down" name="chevron" size="md" />
  </base-button>
</template>

<script lang="ts" setup>
defineProps<{
  /**
   * Unavailable means the variant is out of stock, it will appear disabled but remain selectable
   */
  unavailable?: boolean
  showPlaceholderStockHint?: boolean
}>()

defineEmits<{
  click: []
}>()

const modelValue = defineModel<string>()
const { isNotifyMe } = usePdp() || {}
</script>
